// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3iaSz","colMaxWidth":"Table_colMaxWidth__2fvEv"};